<template>
  <div class="memberCenter_wrap EnterpriseInform">
    <div class="nav_pos mb_nav_pos">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>招标中心</el-breadcrumb-item>
        <el-breadcrumb-item>上传投标文件</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="content_wrap">
      <div id="Shedure" v-if="NeedQuoto != '1'">
        <span class="step" :class="{ active: step >= 2 }">
          1
          <div class="name">上传标书</div>
        </span>
        <div class="line"></div>
        <span class="step" :class="{ active: step >= 3 }">
          2
          <div class="name">成功提交</div>
        </span>
      </div>
      <div id="Shedure" v-if="NeedQuoto == '1'">
        <span class="step" :class="{ active: step >= 1 }">
          1
          <div class="name">填写报价</div>
        </span>
        <div class="line"></div>
        <span class="step" :class="{ active: step >= 2 }">
          2
          <div class="name">上传标书</div>
        </span>
        <div class="line"></div>
        <span class="step" :class="{ active: step >= 3 }">
          3
          <div class="name">成功提交</div>
        </span>
      </div>
      <div v-show="step == 1">
        <div id="title" style="height: 20px; width: auto; border-bottom: 1px solid #95c7f0; font-size: 17px; margin: 0 0 10px 0">
          <span>
            <strong>报价信息</strong>
          </span>
        </div>

        <div id="SpreadJsDiv"></div>
        <!-- <iframe
          id="iframeSpreadJs"
          name="iframeSpreadJs"
          width="100%"
          height="333px"
          frameborder="0"
          scrolling="auto"
          src="http://172.18.11.50:8022"
        ></iframe>-->
        <div class="btn_wrap">
          <!-- <span class="btn btn_reg2" @click.stop="apply">apply</span> -->
          <span class="btn btn_reg2" @click.stop="CancelEvents">取消</span>
          <span class="btn btn_reg" @click.stop="NextStepEvents">下一步</span>
        </div>
      </div>
      <div v-show="step == 2">
        <div id="title" style="height: 20px; width: auto; border-bottom: 1px solid #95c7f0; font-size: 17px; margin: 0 0 10px 0">
          <span>
            <strong>投标文件</strong>
          </span>
        </div>

        <div id="FileList" ref="FileList">
          <table>
            <thead>
              <tr>
                <th width="30%">序号</th>
                <th width="36%">投标文件</th>
                <th width="35%">状态</th>
              </tr>
            </thead>
            <tbody>
              <tr class="quote" @click="ChangeShow(false)" :class="{ tender: !showQuoto }">
                <!-- <td v-if="this.NeedQuoto=='1'">1</td> -->
                <td>1</td>
                <td>
                  <span class="switch">标书</span>
                </td>
                <td>
                  <span v-show="BidFile == undefined || BidFile == ''">
                    <el-link :underline="false" style="color: #054c81">---</el-link>
                  </span>
                  <span
                    v-show="BidFile != undefined && BidFile != ''"
                    class="el-icon-circle-check"
                    style="color: green; font-size: 20px; font-weight: bold"
                  ></span>
                  <!-- <el-button type="text" size="small" @click="fnUploadFile">上传文件</el-button>
                  <input
                    ref="filElem"
                    class="input_file"
                    v-show="false"
                    type="file"
                    @change="getFile"
                  />-->
                </td>
              </tr>
              <tr class="quote" v-if="this.NeedQuoto == '1'" @click="ChangeShow(true)" :class="{ tender: showQuoto }">
                <td>2</td>
                <td>
                  <span class="switch">报价预览表</span>
                </td>
                <td>
                  <span v-show="QuotoFile == undefined || QuotoFile == ''"><el-link :underline="false" style="color: #054c81">---</el-link></span>
                  <span
                    v-show="QuotoFile != undefined && QuotoFile != ''"
                    class="el-icon-circle-check"
                    style="color: green; font-size: 20px; font-weight: bold"
                  >
                  </span>
                </td>
              </tr>
              <tr class="quote" v-if="this.NeedQuoto == '0'">
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr class="quote">
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr class="quote">
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div id="BJCAPdfDiv"></div>
        <div class="btn_wrap">
          <span class="btn btn_reg2" v-show="this.NeedQuoto == '1'" @click.stop="LastStepEvents">上一步</span>
          <span class="btn btn_reg" @click.stop="SubmitEvents">确认提交</span>
        </div>
      </div>

      <div v-show="step == 3">
        <div class="Tip">
          <div id="tip1">已提交投标文件！</div>
          <div id="tip2">温馨提示：在投标截止时间内，如需修改投标文件，请撤标后重新上传！</div>
        </div>
        <div class="btn_wrap">
          <span class="btn btn_reg" @click.stop="CancelEvents">确认</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from '@/assets/js/swiper.min.js'
import jsSHA from '@/assets/js/sha.js'
export default {
  data() {
    return {
      SpreadUrl: '',
      // QuoFinished: false,
      // BidFinished:false,
      NeedQuoto: '1',
      QuotoFile: '',
      BidFile: '',
      showQuoto: true,
      filePath: '',
      Content: '',
      Jsonstr: '',
      step: 1,
      key: '',
      File: {},
      fileUrl: 'C://1M.pdf',
      savePath: 'http://localhost:28920/SupplierLogin/UploadFile2', //"C:\\gyc.pdf",
      saveType: 'net',
      token: '123456'
    }
  },
  updated() {},
  mounted() {
    this.NeedQuoto = this.$route.query.NeedQuoto
    // console.log(this.NeedQuoto==false);
    // window.init(//初始化CA插件
    //   function() {
    //     window.console.log("sucess");
    //   },
    //   function() {
    //     // window.console.log("fail");
    //     this.$message.error("CA插件初始化失败");
    //   }
    // );
    if (this.NeedQuoto == '1') {
      this.fnInit()
      //初始化信息
      // this.fnInit();
    } else {
      this.NextStepEvents()
      this.ChangeShow(false)
    }
  },
  methods: {
    ChangeShow(obj) {
      this.showQuoto = obj
      this.viewPdf()
    },
    apply() {
      this.getRequest('/Purchase/ApplyCert')
        .then((res) => {})
        .catch(function (error) {
          console.log(error)
        })
    },
    fnInit() {
      let config = {
        params: {
          SchemeId: this.$route.query.SchemeId
        }
      }
      //加载SpreadJs显示内容
      this.getRequest('/Purchase/GetQuotoSSjson', config)
        .then((res) => {
          var data = res.data
          if (data.errcode == 0) {
            this.Jsonstr = data.ssjson
            this.key = data.key
            this.SpreadUrl = data.SpreadUrl
            document.getElementById('SpreadJsDiv').innerHTML =
              '<iframe @load="setIframeHeight" id="iframeSpreadJs" ref="iframeSpreadJs" name="iframeSpreadJs" width="100%" height="600px" frameborder="0" scrolling="auto" src="' +
              this.SpreadUrl +
              '"></iframe>'

            //初始化SpreadJs
            var frm = document.getElementById('iframeSpreadJs')
            // if (window.location.hostname != "localhost")
            frm.src = this.SpreadUrl
            // frm.src = "http://172.18.0.242:8022";
            var jsonStr = ''

            // frm.height = document.documentElement.clientHeight - 400;
            setTimeout(() => {
              this.fnAddSJInitListener()
            }, 1000)
          } else {
            this.$message.error(data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    setIframeHeight() {
      this.$refs['iframeSpreadJs'].style.height = $(window).height() - 230
    },
    SubmitEvents() {
      if (this.NeedQuoto == '1') {
        if (this.QuotoFile == undefined || this.QuotoFile == '') {
          this.$message.error('投标报价文件还未签章，请确认签章后提交')
          return
        }
      }
      if (this.BidFile == undefined || this.BidFile == '') {
        this.$message.error('投标文件还未签章，请确认签章后提交')
        return
      }
      let config = {
        params: {
          AutoId: this.$route.query.id,
          Quota: this.QuotoFile,
          BidFile: this.BidFile
        }
      }
      //确认投标
      this.postRequest('Purchase/ConfirmTender', {
        AutoId: this.$route.query.id,
        DecryptKey: '',
        ConfirmBidding: true,
        QuotoFile: this.QuotoFile,
        BidFile: this.BidFile,
        ssjson: this.Content
      })
        .then((res) => {
          var data = res.data
          if (data.errcode == 0) {
            this.step++
            // this.$message({ type: "success", message: "成功接受邀请!" });
            localStorage.setItem('TenderDocList', Math.random()) //刷新父页面
          } else {
            this.$message.error(data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    LastStepEvents() {
      if (this.NeedQuoto == '1') {
        this.step--
        if (this.step == 1) {
          //移除CA监听，添加SpreadJs保存监听
          this.fnRemoveCAListener()
          // this.fnAddSaveSpreadListener();
        }
      }
    },
    fnAddSJInitListener() {
      console.log('成功添加初始化监听')
      window.addEventListener('message', this.fnLoadSpreadJs)
    },
    fnSaveSpreadJsContent(e) {
      this.Content = e.data
      console.log(this.Content)
      this.postRequest('/Purchase/SaveQuotoFile', {
        SchemeId: this.$route.query.SchemeId,
        ssjson: e.data,
        chackFixedPrice: true
      })
        .then((res) => {
          var data = res.data
          if (data.errcode == 0) {
            this.step++
            this.filePath = data.filePath
            this.viewPdf()
          } else if (data.errcode == 2) {
            this.$confirm(data.errmsg, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.postRequest('/Purchase/SaveQuotoFile', {
                SchemeId: this.$route.query.SchemeId,
                ssjson: e.data,
                chackFixedPrice: false
              })
                .then((res) => {
                  var data = res.data
                  if (data.errcode == 0) {
                    this.step++
                    this.filePath = data.filePath
                    this.viewPdf()
                  } else {
                    this.$message.error(data.errmsg)
                  }
                })
                .catch(function (error) {
                  console.log(error)
                })
            })
          } else {
            this.$message.error(data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      window.removeEventListener('message', this.fnSaveSpreadJsContent) //移除监听事件
      console.log('移除保存监听')
    },

    fnAddCAListener() {
      console.log('添加CA监听')
      window.addEventListener('message', this.fnSaveCAContent)
    },
    fnRemoveCAListener() {
      console.log('移除CA监听')
      window.addEventListener('message', this.fnSaveCAContent)
    },
    fnAddSaveSpreadListener() {
      console.log('添加保存监听')
      var that = this
      var frm = document.getElementById('iframeSpreadJs')

      var jsonStr = '{"MsgType":"GetData"}' //发送消息到SpreadJS

      //上传报价单文件
      frm.contentWindow.postMessage(jsonStr, frm.src) //发送消息到SpreadJS

      window.addEventListener('message', this.fnSaveSpreadJsContent)
    },
    NextStepEvents() {
      if (this.step == 1) {
        if (this.NeedQuoto == '1') {
          this.fnAddSaveSpreadListener()
          window.removeEventListener('message', this.fnLoadSpreadJs)
        } else {
          this.step++
        }
        this.fnAddCAListener()
      }
      // this.step++;
      // if (this.step == 2) {
      //   //跳转到第二步，先存储数据

      //   if (this.NeedQuoto == "1") {
      //     this.fnAddSaveSpreadListener();
      //     window.removeEventListener("message", this.fnLoadSpreadJs);
      //   }
      //   this.fnAddCAListener();
      // }
    },
    CancelEvents() {
      window.close()
    },
    fnSaveCAContent(e) {
      if (e.data.type == 'signPdfBase64') {
        console.log('开始保存CA的内容')
        if (e.origin != 'https://127.0.0.1:21061' && e.origin != 'http://127.0.0.1:21051') return
        var message = e.data.contents
        if (this.showQuoto) {
          this.QuotoFile = e.data.contents
          // this.QuoFinished = true;
        } else {
          // this.BidFinished = true;
          this.BidFile = e.data.contents
        }
      }
    },
    fnLoadSpreadJs(e) {
      var that = this
      // window.console.log(222222)
      // $("#iframeSpreadJs").css("height",$(window).height() - 67)
      // window.addEventListener("message", function(e) {
      // console.log(e);
      // console.log("开始加载SpreadJs");
      // if (e.data != "loadCompleted") return;
      // // var jsonStr =
      // //   '{"MsgType":"InitData","Data":"' +
      // //   that.Jsonstr +
      // //   '","ShowMenuType":2}';

      // var frm = document.getElementById("iframeSpreadJs");
      // frm.style.height = $(window).height() - 67+"px"
      // console.log(222);
      // $("#iframeSpreadJs").height($(window).height() - 67);

      // });
      var jsonStr = '{"MsgType":"InitData","Data":"' + that.Jsonstr + '","ShowMenuType":1}'
      var frm2 = document.getElementById('iframeSpreadJs')

      frm2.contentWindow.postMessage(jsonStr, this.SpreadUrl) //发送消息到SpreadJS
      // this.$nextTick(() => {
      //   document.getElementById('iframeSpreadJs').style.height = $(window).height() - 230
      // })

      // console.log(111,$("#iframeSpreadJs"));
    },
    //       if (e.data.type == "signPdfBase64") {
    //         if (e.data.type == "webpackOk")
    fnUploadFile() {
      //选择文件
      this.$refs.filElem.dispatchEvent(new MouseEvent('click'))
    },
    getObjectURL(file) {
      var reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = function (e) {
        // imgSrc = this.result;
        return this.result
      }
      // let url = null;
      // if (window.createObjectURL != undefined) {
      //   // basic
      //   url = window.createObjectURL(file);
      // } else if (window.webkitURL != undefined) {
      //   // webkit or chrome
      //   url = window.webkitURL.createObjectURL(file);
      // } else if (window.URL != undefined) {
      //   // mozilla(firefox)
      //   url = window.URL.createObjectURL(file);
      // }
      // return url;
    },
    getFile() {
      let filesDom = document.getElementsByClassName('input_file')[0]
      var aaa = this.getObjectURL(this.$refs.filElem.files[0])
      console.log(aaa)
      // var that = this;
      // const inputFile = this.$refs.filElem.files[0];
      // if (inputFile) {
      //   if (inputFile.type !== "application/pdf") {
      //     alert("不是有效的PDF文件！");
      //     return;
      //   }
      //   this.imgInfo = Object.assign({}, this.imgInfo, {
      //     name: inputFile.name,
      //     size: inputFile.size,
      //     lastModifiedDate: inputFile.lastModifiedDate.toLocaleString()
      //   });
      //   const reader = new FileReader();
      //   reader.readAsDataURL(inputFile);
      //   reader.onload = function(e) {
      //     that.imgSrc = this.result;
      //   };
      // } else {
      //   return;
      // }
    },
    changeFrameHeight() {
      var ifm = document.getElementById('BJCAPdfJsViewer')
      var FileListt = document.documentElement.clientHeight - (60 + 45 + 42 + 21 + 32)
      ifm.height = document.documentElement.clientHeight - 210 - 20
      this.$refs.FileList.style.height = FileListt + 'px'
      var ifm = document.getElementById('BJCAPdfJsViewer2')
      ifm.height = document.documentElement.clientHeight - 6
    },
    onresize() {
      window.onresize = function () {
        this.changeFrameHeight()
      }
    },
    viewPdf() {
      var path = ''
      console.log(this.showQuoto)
      if (this.showQuoto) path = window.location.origin + this.filePath
      else path = this.fileUrl
      console.log(path)
      let height = document.documentElement.clientHeight - 500
      window.console.log(height)
      if (this.showQuoto) {
        document.getElementById('BJCAPdfDiv').innerHTML =
          '<iframe src="http://127.0.0.1:21051/PDFClient/viewer.html?encode=1&fileUrl=' +
          path +
          '&savePath=' +
          this.savePath +
          '&saveType=' +
          this.saveType +
          '&token=' +
          this.token +
          '" id="BJCAPdfJsViewer" frameborder="0" scrolling="auto" width="80%" height="200"></iframe>'
      } else {
        document.getElementById('BJCAPdfDiv').innerHTML =
          '<iframe src="http://127.0.0.1:21051/PDFClient/viewer.html?encode=1' +
          '&savePath=' +
          this.savePath +
          '&saveType=' +
          this.saveType +
          '&token=' +
          this.token +
          '" id="BJCAPdfJsViewer" frameborder="0" scrolling="auto" width="80%" height="200"></iframe>'
      }

      var frm = document.getElementById('#BJCAPdfJsViewer')

      this.changeFrameHeight()
    },
    fnaddlistner() {
      // 接收demo.me的数据
      window.addEventListener(
        'message',
        function (e) {
          if (e.origin != 'https://127.0.0.1:21061' && e.origin != 'http://127.0.0.1:21051') return
          var message = e.data
          //var message = JSON.parse(data);
          if (message.type == 'signPdfBase64') {
            // alert(message.contents);
            Console.log('signPdfBase64')
          } else if (message.type == 'serviceSignInfo') {
            Console.log('serviceSignInfo')
            for (var p in message.serviceSignInfos) {
              var serviceSignInfo = message.serviceSignInfos[p]
              var sealImage = serviceSignInfo.sealImage
              var pageNum = serviceSignInfo.pageNum
              var left = serviceSignInfo.left
              var top = serviceSignInfo.top
              var right = serviceSignInfo.right
              var bottom = serviceSignInfo.bottom
              var info = 'pageNum:' + pageNum + '  left:' + left + '  top:' + top + '  right:' + right + '  bottom:' + bottom
              alert(info)
            }
          }
        },
        false
      )
    }
  }
}
</script>
<style scoped lang="scss">
.btn_wrap {
  display: block;
  text-align: center;
  margin-top: 15px;
  .btn {
    margin: 10px;
    color: #6a96bc;
    border: 1px solid #6a96bc;
    border-radius: 20px;
    padding: 5px 30px;
    cursor: pointer;
    // margin:auto;
  }
  .btn_reg {
    background: #0774d7;
    color: white;
  }
  .btn_reg2 {
    background: #2db7f5;
    color: white;
  }
}
.currentMenu {
  padding: 9px;
  margin: 7px;
}
.Tip {
  text-align: center;
  margin-top: 50px;
  margin-bottom: 50px;
  #tip1 {
    font-size: 16px;
    font-style: initial;
    font-weight: bold;
    padding-bottom: 20px;
    color: #0774d7;
  }
}
#FileList table tbody tr {
  height: 25px;
}
.quote td {
  background-color: #f8fbfe;
  padding: 10px;
  cursor: pointer;
}
.tender td {
  background-color: #d8eafa;
  padding: 10px;
  cursor: pointer;
}
#FileList {
  float: left;
  width: 18%;
  margin-right: 10px;
  height: 500px;
  background-color: #f8fbfe;
}

#FileList table {
  width: 100%;
  text-align: center;
}
#FileList td {
  height: 20px;
}
#FileList table thead {
  margin: 10px;
  color: white;
  background-color: #4f99d7;
}
#FileList table thead th {
  padding: 14px;
}
.memberIndex {
  display: flex;
  .left {
    width: 250px;
    min-width: 250px;
    background: #4f99d7;
    .logined_wrap {
      padding: 10px;
      .title span:nth-of-type(1) {
        font-weight: bold;
        color: #fff;
        margin-right: 5px;
      }
      .btn {
        border-top: 1px dashed #2db7f5;
        padding-top: 10px;
        margin-top: 10px;
      }
      // .btn_1 {
      //   width: 100%;
      // }
      .img {
        margin-left: 30px;
      }
      .list {
        li {
          font-size: 12px;
          padding: 5px 0;
          color: #d3e7f3;
          display: flex;
          align-items: center;
          .labell {
            font-weight: bold;
          }
          img {
            margin-right: 5px;
          }
        }
      }
    }
  }
  .right {
    background: #e4e4e4;
    flex: 1;
    padding: 0 0 10px 0;
    .right_out {
      width: 98%;
      margin: 0 auto;
    }
    .welcome {
      height: 40px;
      line-height: 40px;
    }
  }

  .block_wrap {
    display: flex;
  }
  .left_block {
    flex: 3;
    .flex_block {
      display: flex;
      .block {
        flex: 1;
        background: #fff;
        margin-right: 20px;
        text-align: center;
        align-items: center;
        padding: 13px 0;
        .text1 {
          font-size: 46px;
          color: #219cf8;
        }
        .text2 {
          margin-top: 4px;
          color: #054c81;
        }
      }
      .block:nth-last-of-type(1) {
        margin-right: 0;
      }
    }
  }
  .flex_bottom {
    padding: 10px 15px 3px;
    background: #fff;
    margin-top: 10px;
    .fb_title {
      margin-bottom: 0;
    }
  }
  .right_block {
    width: 220px;
    background: #fff;
    margin-left: 10px;
    padding: 18px 15px 0;
    .text {
      font-size: 16px;
      border-bottom: 1px solid #95c7f0;
      padding-bottom: 3px;
      font-weight: bold;
    }
    .row_imgs {
      display: flex;
      margin: 15px 0 25px;
      .img_block {
        flex: 1;
        text-align: center;
        cursor: pointer;
        img {
          margin-bottom: 20px;
        }
      }
    }
    .row_imgs:nth-last-of-type(1) {
      margin-top: 33px;
    }
  }
}
#Shedure {
  height: 42px;
  width: auto;
  text-align: center;
  color: white;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  .step {
    position: relative;
    border-radius: 50%;
    background: #e4e4e4;
    text-align: center;
    color: #999;
    display: inline-block;
    width: 30px;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
    .name {
      position: absolute;
      bottom: -27px;
      left: -11px;
      color: #999;
      white-space: nowrap;
    }
  }
  .active {
    color: #fff;
    background: #054c81;
    .name {
      color: #666;
    }
  }
  .line {
    width: 300px;
    height: 8px;
    background: #e4e4e4;
  }
}
.switch {
  cursor: pointer;
}

.mb_nav_pos {
  padding: 5px 0 0;
}
.EnterpriseInform {
  .content_wrap {
    padding-bottom: 20px;
    // padding-bottom: 50px;
    // margin-bottom: 20px;
  }
}
</style>
